import * as ko from "knockout";
import { Period } from "./period";

export class LiveSubscriptionReportParams {
    periodIds: any;

    periods: any;
    topicIds: any;
    paperIds: any;
    addressIds: any;
    recipients: any;
    statuses: any;

    constructor() {
        this.periodIds = ko.observableArray<string>();
        this.periods = ko.observableArray<Period>();
        this.topicIds = ko.observableArray<number>();
        this.paperIds = ko.observableArray<number>();
        this.addressIds = ko.observableArray<number>();
        this.recipients = ko.observableArray<string>();
        this.statuses = ko.observableArray<string>();
    }
}